module.exports = __webpack_public_path__ + "static/media/008-circle-purple.bff3a420.svg";